// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__AzJIP","additionalInfo":"AgreementModal_additionalInfo__2eYgb"};